function watchInit() {
  let watchBtn = document.querySelectorAll('.watch__button');
  let watchPlayer = document.querySelectorAll('.watch__player');

  watchBtn.forEach((btn, i) => {
    btn.addEventListener('click', () => {
      watchBtn.forEach((otherBtn, j) => {
        if (j === i) {
          otherBtn.classList.add('is-active')
        } else {
          otherBtn.classList.remove('is-active')
        }
      })
      watchPlayer.forEach((player, j) => {
        if (j === i) {
          player.classList.add('is-active')
        } else {
          player.classList.remove('is-active')
        }
      })
    })
  })
}

export { watchInit }